import {
    DeliveryType,
    FocusContainerRefDto,
} from '../../coaching-base/general';
import { manageNotes } from '../../coaching-note/note-detail.form';

import { ChainGroup } from './observation.epic';
import {
    CoachingInteractionModel,
    InteractionScoringModel,
    ObservationEvent,
} from './observation.model';

// TODO transformer?
export function composeObservation<TPayload>(
    grp: ChainGroup<TPayload>,
    deliveryTypeId: DeliveryType,
    startTime: Date,
    duration: number,
    focusContainers: FocusContainerRefDto[],
    // interactions: Array<CoachingInteractionModel>,
    // notes: Array<NoteDetails>,
    share: boolean,
    publish: boolean,
): ObservationEvent {
    const manageScoring = (
        scoring_: InteractionScoringModel[],
        owner: CoachingInteractionModel,
    ): InteractionScoringModel[] => {
        return (scoring_ || []).map((e) => ({
            ...e,
            interactionScoringId:
                e.interactionScoringId != null ? e.interactionScoringId : 0, // reasons
            interactionId:
                owner.interactionId != null ? owner.interactionId : undefined,
            proficiencyDelivered:
                e.proficiencyDelivered > 0 ? e.proficiencyDelivered : undefined, // TODO revise what if configured min is > 1 or <= 0
            consistencyDelivered:
                e.consistencyDelivered > 0 ? e.consistencyDelivered : undefined, // TODO revise what if configured min is > 1 or <= 0
            confidenceDelivered:
                e.confidenceDelivered > 0 ? e.confidenceDelivered : undefined, // TODO revise what if configured min is > 1 or <= 0
            focusId: e.focusId != null ? e.focusId : undefined,
        }));
    };

    return {
        eventId: grp.event.eventId != null ? grp.event.eventId : 0, // reasons
        eventTypeId: grp.event.eventTypeId,
        deliveryTypeId: grp.event.published
            ? grp.event.deliveryTypeId
            : deliveryTypeId,
        sessionDate: grp.event.sessionDate,
        duration: grp.event.published ? grp.event.duration : duration,
        shareWithPerformer: share,
        published: publish,
        startTime: grp.event.published ? grp.event.startTime : startTime,
        endTime: grp.event.published
            ? grp.event.endTime
            : new Date(startTime.getTime() + duration * 60000),
        participants: [grp.performer, grp.observer]
            .filter((e) => !!e)
            .map((e) => ({
                eventId: grp.event.eventId != null ? grp.event.eventId : 0, // reasons
                userId: e.userId,
                coachingRoleId: e.coachingRoleId,
            })),
        /* interactions: (interactions || []).map(e => ({
            ...e,
            interactionId: e.interactionId != null ? e.interactionId : 0, // reasons
            interactionIdentifier: e.interactionIdentifier ? e.interactionIdentifier : '',
            performerId: grp.performer.userId,
            observerId: grp.observer.userId,
            queueId: e.queueId != null ? e.queueId : undefined,
            notes: manageNotes(e.notes, grp.performer.userId, publish),
            tags: manageTags(e.tags, grp.performer.userId),
            scoring: manageScoring(e.scoring, e)
        })),
        notes: manageNotes(notes, grp.performer.id, publish), */
        interactions: null,
        notes: null,
        focusContainers: (focusContainers || []).map((ctr) => ({
            ...ctr,
            metrics: ctr.metrics || [],
            interactions: (ctr.interactions || []).map((e) => ({
                ...e,
                interactionId: e.interactionId != null ? e.interactionId : 0, // reasons
                interactionIdentifier: e.interactionIdentifier
                    ? e.interactionIdentifier
                    : '',
                performerId: grp.performer.userId,
                observerId: grp.observer.userId,
                queueId: e.queueId != null ? e.queueId : undefined,
                notes: manageNotes(e.notes, grp.performer.userId, publish),
                scoring: manageScoring(e.scoring, e),
            })),
        })),
    };
}
